import { motion } from 'framer-motion'
import SectionHeading from '../shared/SectionHeading'
import './Contact.css'
import { FaEnvelope } from 'react-icons/fa'

const socialLinks = [
  { url: 'https://github.com/PasinduPerera10', icon: 'fab fa-github', label: 'GitHub' },
  { url: 'https://www.linkedin.com/in/pasindu-perera-120752221', icon: 'fab fa-linkedin-in', label: 'LinkedIn' },
  { url: 'https://www.facebook.com/pasindu.manjitha.5', icon: 'fab fa-facebook-f', label: 'Facebook' },
  { url: 'https://www.instagram.com/pasindu._perera._/', icon: 'fab fa-instagram', label: 'Instagram' },
  { url: 'https://twitter.com/PasinduPerera99', icon: 'fab fa-twitter', label: 'Twitter' },
  { url: 'https://medium.com/@pasinduperera10', icon: 'fab fa-medium-m', label: 'Medium' }
]

const Contact = () => (
  <section className="contact-container" id="contact">
    <SectionHeading icon={<FaEnvelope />}>Get In Touch</SectionHeading>
    <motion.p
      className="contact__text"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      Feel free to reach out for collaborations or just a friendly chat
    </motion.p>
    <motion.div
      className="contact__socials"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      {socialLinks.map(({ url, icon, label }, i) => (
        <motion.a
          key={i}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="contact__icon"
          whileHover={{ y: -5, scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          title={label}
        >
          <i className={icon}></i>
        </motion.a>
      ))}
    </motion.div>
  </section>
)

export default Contact
